import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FilterBar } from './components/FilterBar';
import { FeaturedGrid } from './components/FeaturedGrid';
import { HowItWorks } from './components/HowItWorks';
import { TrustSection } from './components/TrustSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-white font-sans selection:bg-gold-500 selection:text-dark-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <FilterBar data-id="element-4" />
        <FeaturedGrid data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <TrustSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}